import {
  accessToken,
  removeAccessToken,
  removeRefreshToken
} from '../tokens'
import { revokeAuthTokens } from './apiRequest'
import bugsnag from 'bugsnag'

const digitalSignOutToClient = `${process.env.REACT_APP_DIGITAL_CLIENT_HOST}/people/sign_out`
const digitalSignOutToMarketing = `${process.env.REACT_APP_DIGITAL_CLIENT_HOST}/people/sign_out?send_to_marketing=true`
export const samlIdpInitiatedUrl = `${process.env.REACT_APP_DIGITAL_CLIENT_HOST}/app/bd/sso/saml?redirect_from_pwm=true`
const redirectToLogin = (redirectHost = 'digitalClient') => {
  window.location = redirectHost === 'digitalClient' ? digitalSignOutToClient : digitalSignOutToMarketing
}

const logOut = async (redirectHost = 'digitalClient') => {
  const missingAccessToken = accessToken() == null

  if (!missingAccessToken) {
    try {
      await revokeAuthTokens()
    } catch (error) {
      bugsnag.notify(error)
    }
    removeAccessToken()
  }

  removeRefreshToken()
  redirectToLogin(redirectHost)
}

export default logOut



// WEBPACK FOOTER //
// ./src/utils/Client/authentication.js